import { mapGetters } from 'vuex'

export default {
    data () {
        
    },
    created: function () {

    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
        }),
        userRole() {
            if(this.user.roles.length) {
                return this.user.roles[0].name
            } else {
                return ''
            }
        }
    },
    methods: {
        
    }
 }